

const ButtonSizes = {
    xs: "xs",
    small: "sm",
    medium: "md",
    large: "lg",
    xl: "xl"
};

const ButtonVariant = {
    standard: "ghost",
    outline: "outline",
    alt: "solid"
};


const CardTypes = {
    two: "GiCard2Spades",
    three: "GiCard3Spades",
    four: "GiCard4Spades",
    five: "GiCard5Spades",
    six: "GiCard6Spades",
    seven: "GiCard7Spades",
    eight: "GiCard8Spades",
    nine: "GiCard9Spades"
}

export {ButtonSizes, ButtonVariant, CardTypes}